import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import { State } from '../state'

/** Resets scenario-owned option state when the records context changes. */
export const resetOnContextChange = store.reducers.extra(
  <TTypeParams extends Plugin.TypeParams>(
    _feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.feature.actions.changeContext],
      reduce: () => State.INITIAL,
    }),
)
